import { useTranslation } from 'react-i18next';
import SolarIcon from 'components/icons/SolarIcon';

const EmptyResult = () => {
    const { t } = useTranslation();
    return (
        <div className="w-100 py-4 text-center text-muted">
            <SolarIcon name="box-seam" className="d-block mx-auto mb-2 fs-2" />
            <div>{t('messNoResult')}</div>
        </div>
    );
};

export default EmptyResult;
